import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useUpdateSubscription() {
  const [fault, setFault] = useState(null);
  const [faultStatus, setFaultStatus] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestUpdateSubscription = (newRequestData) => {
    WebApi.subscriber({
      callName: 'UpdateSubscription',
      keyFactors: ['UpdateSubscription'],
      forceRefresh: true,
      payload: newRequestData,
    })
      .then((response) => {
        if (isMounted.current) {
          setFaultStatus(false);
          const updateSubscription = response.data;
          setUiModel(updateSubscription);
        }
      })
      .catch((error) => {
        console.warn({ error });
        setFaultStatus((prevState) => !prevState);
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestUpdateSubscription, faultStatus];
}

export { useUpdateSubscription };
export default useUpdateSubscription;
